module.exports = __webpack_public_path__ + "media/public/img/landing_page/headout-arrow-6d6609a1c26c52c3530048fd73f94628.png";